import { Model } from "vuex-fetch-factory";

export interface InvoiceRaw {
  relation_id: number;
  invoice_id: number;
  invoice_date: string;
  expiration_date: string;
  amount: number;
  outstanding: number;
}

export class InvoiceModel implements Model<InvoiceModel, InvoiceRaw> {
  public relation_id = 0;
  public invoice_id = 0;
  public invoice_date = "";
  public expiration_date = "";
  public amount = 0;
  public outstanding = 0;

  public getNew(): InvoiceModel {
    return new InvoiceModel();
  }

  public fillModel(raw: InvoiceRaw): this {
    this.relation_id = raw.relation_id;
    this.invoice_id = raw.invoice_id;
    this.invoice_date = raw.invoice_date;
    this.expiration_date = raw.expiration_date;
    this.amount = raw.amount;
    this.outstanding = raw.outstanding;
    return this;
  }

  public getRaw(): InvoiceRaw {
    return {
      relation_id: this.relation_id,
      invoice_id: this.invoice_id,
      invoice_date: this.invoice_date,
      expiration_date: this.expiration_date,
      amount: this.amount,
      outstanding: this.outstanding
    };
  }

  public get url(): string {
    return `api/invoices/${this.invoice_id}/pdf/Factuur ${this.invoice_id}.pdf`;
  }
}
